$["sxcWidget"] = function(name : string, handler : any)
{
	const dataID = "sxcWidget_" + name;

	$.fn[name] = function(cmd : string, arg : any = null)
	{
		this.each((i, e) =>
		{
			switch (cmd)
			{
				case "init":
					if (dataID in e) {
						e[dataID]("destroy");
						delete e[dataID];
					}

					e[dataID] = new handler(e, arg);
					break;

				case "destroy":
					if (dataID in e) {
						e[dataID].destroy();
						delete e[dataID];
					}
					break;

				default:
					if (!(dataID in e)) {
						throw new Error("Widget " + name + " is not initialized when calling " + cmd + ".");
					}

					e[dataID][cmd](arg);
			}
		});
	}
};

class SxcCustomScroll_old
{
	private _$root;
	private _$wrapper;
	private _$track;
	private _$thumb;
	private _$inner;

	constructor(private root : Element, private options : any)
	{
		// logging.log("runs");
		this._$root = $(root);
		// Create two wrappers. The inner wrapper scrolls, the outer wrapper hides the scrollbar
		this._$wrapper = $("<div class='custom-scroll-wrapper' />");
		this._$inner = $("<div class='custom-scroll-inner' />");
		this._$inner.append(this._$root.contents());
		this._$wrapper
			.append(this._$inner)
			.appendTo(this._$root);

		this._$track = $("<div class='custom-scroll-track' />")
			.appendTo(this._$root);
		this._$thumb = $("<div class='custom-scroll-thumb' />")
			.appendTo(this._$track);

		if (this._$root.css("position") === "static") {
			this._$root.css({
				position: "relative"
			});
		}

		this._$wrapper.css({
			overflow: "hidden",
			width: "100%",
			height: "100%",
			boxSizing: "content-box"
		});

		this._$inner.css({
			overflowX: "hidden",
			overflowY: "scroll",
			// width: "100%",
			height: "100%",
			// paddingRight: "20px",
			marginRight: "-20px",
			position: "relative",
			boxSizing: "content-box"
		});

		this._$track.css({
			position: "absolute",
			left: "100%",
			marginLeft: -4,
			top: 0,
			height: "100%",
			background: "transparent",
			width: 2
		});

		this._$thumb.css({
			position: "absolute",
			left: 0,
			top: 0,
			width: "100%",
			height: "100%",
			background: "#21aae2"
		});

		$(window).on("resize", () => this.update());

		this._$inner.on("scroll", (e : Event) => {
			this.update();
			if (this.options && this.options.onScroll) {
				this.options.onScroll(this._$inner[0].scrollTop,
					this._$inner[0].scrollHeight,
					this._$inner.height());
			}
		});

		this.update();
	}

	scrollTo(h : string | number)
	{
		let to : number;

		let sh = this._$inner[0].scrollHeight;

		if (typeof h === "number") {
			to = h
		} else {
			if (h === "bottom") {
				to = sh;
			} else {
				throw new Error("Invalid value: " + h);
			}
		}

		this._$inner[0].scrollTop = to;
	}

	update()
	{
		let h = this._$inner.height();
		let st = this._$inner[0].scrollTop;
		let sh = this._$inner[0].scrollHeight;

		let top = (st / sh * 100) + "%";
		let height = (h / sh * 100) + "%";

		// logging.log("update", h, st, sh, top, height);

		if (sh <= h) {
			this._$track.hide();
		} else {
			this._$track.show();
		}

		this._$thumb.css({top, height})
	}

	destroy()
	{
		// TODO: Restore object
	}
}

class SxcCustomScroll
{
	private _$root;
	private _$wrapper;
	private _$track;
	private _$thumb;
	private _$inner;

	private static scrollBarWidth;

	private static getScrollBarWidth()
	{
		if (!SxcCustomScroll.scrollBarWidth)
		{
			const inner = document.createElement('p');
			inner.style.width = "100%";
			inner.style.height = "200px";

			const outer = document.createElement('div');
			outer.style.position = "absolute";
			outer.style.top = "0px";
			outer.style.left = "0px";
			outer.style.visibility = "hidden";
			outer.style.width = "200px";
			outer.style.height = "150px";
			outer.style.overflow = "hidden";
			outer.appendChild (inner);

			document.body.appendChild (outer);
			let w1 = inner.offsetWidth;
			outer.style.overflow = 'scroll';
			let w2 = inner.offsetWidth;
			if (w1 == w2) w2 = outer.clientWidth;

			document.body.removeChild (outer);

			SxcCustomScroll.scrollBarWidth = w1 - w2
		}

		return SxcCustomScroll.scrollBarWidth;
	}

	constructor(private root : Element, private options : any)
	{
		// logging.log("runs");
		this._$root = $(root);
		// Create two wrappers. The inner wrapper scrolls, the outer wrapper hides the scrollbar
		this._$wrapper = $("<div class='custom-scroll-wrapper' />");
		this._$inner = $("<div class='custom-scroll-inner' />");
		this._$inner.append(this._$root.contents());
		this._$wrapper
			.append(this._$inner)
			.appendTo(this._$root);

		this._$track = $("<div class='custom-scroll-track' />")
			.appendTo(this._$root);
		this._$thumb = $("<div class='custom-scroll-thumb' />")
			.appendTo(this._$track);


		if (this._$root.css("position") === "static") {
			this._$root.css({
				position: "relative"
			});
		}

		this._$wrapper.css({
			position: "absolute",
			top: 0,
			left: 0,
			overflow: "hidden",
			width: "100%",
			height: "100%",
		});

		this._$inner.css({
			position: "absolute",
			top: 0,
			left: 0,
			overflowX: "hidden",
			overflowY: "scroll",
			width: "calc(100% + " + SxcCustomScroll.getScrollBarWidth() + "px)",
			height: "100%",
		});

		this._$track.css({
			position: "absolute",
			left: "100%",
			marginLeft: -4,
			top: 0,
			height: "100%",
			background: "transparent",
			width: 2
		});

		this._$thumb.css({
			position: "absolute",
			left: 0,
			top: 0,
			width: "100%",
			height: "100%",
			background: "#21aae2"
		});

		$(window).on("resize", () => this.update());

		this._$inner.on("scroll", (e : Event) => {
			this.update();
			if (this.options && this.options.onScroll) {
				this.options.onScroll(this._$inner[0].scrollTop,
					this._$inner[0].scrollHeight,
					this._$inner.height());
			}
		});

		this.update();
	}

	scrollTo(h : string | number)
	{
		let to : number;

		let sh = this._$inner[0].scrollHeight;

		if (typeof h === "number") {
			to = h
		} else {
			if (h === "bottom") {
				to = sh;
			} else {
				throw new Error("Invalid value: " + h);
			}
		}

		this._$inner[0].scrollTop = to;
	}

	scrollTop()
	{
		return this._$inner[0].scrollTop
	}

	update()
	{
		let h = this._$inner.height();
		let st = this._$inner[0].scrollTop;
		let sh = this._$inner[0].scrollHeight;

		let top = (st / sh * 100) + "%";
		let height = (h / sh * 100) + "%";

		// logging.log("update", h, st, sh, top, height);

		if (sh <= h) {
			this._$track.hide();
		} else {
			this._$track.show();
		}

		this._$thumb.css({top, height})
	}

	destroy()
	{
		// TODO: Restore object
	}
}


$["sxcWidget"]("sxcCustomScroll", SxcCustomScroll_old);
$["sxcWidget"]("sxcCustomScroll2", SxcCustomScroll);
